export default __webpack_public_path__ + "static/media/MusicalIntruments_26.28ea8259.png";